<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logo2.png" v-else />
      </div>
    </div>

    <div class="whiteBg">
      <div class="title">测试用户登录</div>

      <div class="tip">
        町当
      </div>
    </div>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { setTestUser } from "@api/user";
import store from "@/store";
const WX_AUTH = "wx_auth";

export default {
  name: "setTestUser",
  mixins: [sendVerifyCode],
  data: function() {
    return {};
  },
  mounted: function() {
    this.setTestUser();
  },
  methods: {
    setTestUser() {
      setTestUser()
        .then(res => {
          var data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          store.commit("LOGIN", datas);
          this.$dialog.success("登录成功");
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.code img {
  width: 100%;
  height: 100%;
}
</style>
